import React from "react";

function Timeline() {

  const milestones = [
    {
      id: 1,
      year: "Months 1-12",
      text: "Purchase Billboards over 12 month period for Fund One"
    },
    {
      id: 2,
      year: "Months 6-72",
      text: "Manage Billboards and plan to return distributions to investors on a quarterly basis"
    },
    {
      id: 3,
      year: "Months 42-72",
      text: "Sale of Billboards, plan to return proceeds of sale to investors"
    },
 
  ];

  return (
    <section className='business-card'>
      
      <h5
        style={{
          fontSize: ".72rem",
          letterSpacing: ".14em",
          textTransform: "uppercase",
          color: "var(--gold)",
          marginBottom: "20px",
          fontFamily: "'Founders Grotesk', sans-serif",
          fontWeight: 700
        }}
      >
        Development Milestones
      </h5>

      <div className="timeline">

        {milestones.map((milestone) => (
          <div className="tl-item" key={milestone.id}>

            <div className="tl-year">
              {milestone.year}
            </div>

            <div className="tl-text">
              {milestone.text}
            </div>

          </div>
        ))}

      </div>

    </section>
  );
}

export default Timeline;